let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aZwOd"), load("k9ktU"), load("8Kyi2")]).then(() => parcelRequire('4I77f'));